import { render } from "./MatchGroupMenu.vue?vue&type=template&id=82adf9b6&scoped=true"
import script from "./MatchGroupMenu.vue?vue&type=script&lang=js"
export * from "./MatchGroupMenu.vue?vue&type=script&lang=js"

import "./MatchGroupMenu.vue?vue&type=style&index=0&id=82adf9b6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82adf9b6"]])

export default __exports__